export const globalSale = {
  active: true,
  label: 'Lean Summer Sale',
}

export const featuredProductIds = ['retatrutide', 'tirzepatide', 'bpc157']

export const CATALOG_LINE = {
  ALL: 'all',
  VIALS: 'vials',
  BEAUTY: 'beauty',
}

export const CATALOG_SORT = {
  CONFIG: 'config',
  ALPHA: 'alpha',
}

export const catalogSortByLine = {
  [CATALOG_LINE.ALL]: CATALOG_SORT.ALPHA,
  [CATALOG_LINE.VIALS]: CATALOG_SORT.CONFIG,
  [CATALOG_LINE.BEAUTY]: CATALOG_SORT.ALPHA,
}
